// Semi-Private Training page — who-it's-for tabs + FAQ accordion (single-open).
// Bundled into app.min.js; guarded by .tp-sp so it no-ops elsewhere.
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.tp-sp');
    if (!root) return;

    // ── Who tabs ──
    var tabs = root.querySelectorAll('.sp-who__tab');
    var panels = root.querySelectorAll('.sp-who__panel');
    if (tabs.length && panels.length) {
        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                var idx = tab.getAttribute('data-sp-tab');
                tabs.forEach(function (t) {
                    var on = t === tab;
                    t.classList.toggle('is-active', on);
                    t.setAttribute('aria-selected', on ? 'true' : 'false');
                });
                panels.forEach(function (p) {
                    var on = p.getAttribute('data-sp-panel') === idx;
                    p.classList.toggle('is-active', on);
                    if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
                });
            });
        });
    }

    // ── FAQ accordion (single-open) ──
    var items = root.querySelectorAll('.sp-faq__item');
    if (items.length) {
        items.forEach(function (item) {
            var btn = item.querySelector('.sp-faq__q');
            if (!btn) return;
            btn.addEventListener('click', function () {
                var open = item.classList.contains('is-open');
                items.forEach(function (o) {
                    o.classList.remove('is-open');
                    var b = o.querySelector('.sp-faq__q');
                    if (b) b.setAttribute('aria-expanded', 'false');
                });
                if (!open) {
                    item.classList.add('is-open');
                    btn.setAttribute('aria-expanded', 'true');
                }
            });
        });
    }
});
